import moment from 'moment-timezone'
import { generateSequence } from './utils'

const months = moment.monthsShort()

export const colorOptions = [
  '#CDDEE0',
  '#7E9EE4',
  '#F8D86E',
  '#1E2847',
  '#ff7865',
  '#e9c5b3',
]

export function generateYearMonthOptions(fromMonths = 0, months = 12, format = 'YY-M') {
  const options: Array<string> = []

  for (let i = 0; i < months; i += 1) {
    const d = moment().subtract(fromMonths, 'months').add(i, 'months')
    options.push(d.format(`${format}`))
  }

  return options
}

export function timeLabel(time: number) {
  if (time < 10) return `0${time}`
  return time
}

export function durationLabel(duration: number) {
  const minutes = duration % 60
  const hours = Math.floor(duration / 60)

  if (hours === 0) return `${minutes} mins`

  return `${hours} hour, ${minutes} mins`
}

export function yearMonthLabel(yearMonth: string) {
  const dateParts = yearMonth.split('-')

  if (dateParts.length < 2) return ''

  const i = (parseInt(dateParts[1]!, 10) - 1) % 12
  return `${months[i]}`
}

export interface MonthData {
  monthYear: string
  daysOfMonth: string[]
  isThisMonth: boolean
  todayOfMonth: string
}

const monthYearFormat = 'MMMM YYYY'

export function generateMonthsDays(fromMonths = 0, months = 12) {
  const monthOptions = generateYearMonthOptions(fromMonths, months, monthYearFormat)

  const monthsData: MonthData[] = []

  monthOptions.forEach(monthYear => {
    monthsData.push({
      monthYear,
      daysOfMonth: daysForMonthYear(monthYear),
      isThisMonth: moment().format(monthYearFormat) === monthYear,
      todayOfMonth: `${moment().date()}`,
    })
  })

  return monthsData
}

export const daysForMonthYear = (monthYear: string) => {
  const firstDay = moment(`${monthYear} 01`, `${monthYearFormat} DD`)
  let firstDayInWeek = firstDay.day()
  // 0 is Sunday, which we need to wrap back round for the array logic below to work
  if (firstDayInWeek === 0) firstDayInWeek = 7
  const daysInMonth = firstDay.daysInMonth()
  const lastDayInWeek = moment(`${monthYear} ${daysInMonth}`, `${monthYearFormat} DD`).day()

  return [
    ...Array.from({ length: firstDayInWeek - 1 }, _ => ' '),
    ...generateSequence(1, daysInMonth, 1).map(day => `${day}`),
    ...Array.from({ length: 7 - lastDayInWeek }, _ => ' '),
  ]
}

export const generateDaysofTheWeekOptions = (format?: string) => {
  return [...Array(7).keys()].map(offset => ({
    id: `w${offset}`,
    title: moment().startOf('week').add(offset, 'days').format(format || 'ddd'),
  }))
}

export const generateDaysofTheMonthOptions = (days = 31) => {
  return [...Array(days).keys()].map(offset => ({
    id: `m${offset + 1}`,
    title: moment().startOf('year').add(offset, 'days').format('DD'),
  }))
}

export const generateAllYearMonthOptions = (format = 'YY-M') => {
  const options: Array<string> = []

  for (let i = 0; i < 12; i += 1) {
    const d = moment().startOf('year').add(i, 'months')
    options.push(d.format(`${format}`))
  }

  return options
}

export const minutesToTime = (minutes: number) => {
  const hour = `${Math.floor(minutes / 60)}`.padStart(2, '0')
  const mins = `${minutes % 60}`.padStart(2, '0')

  return `${hour}:${mins}`
}